import React, { useEffect } from 'react';

/**
 * Annual/decennial: state is orange (seen in an older month, not current). User picks add vs remove.
 */
const OrangeStateChoiceModal = ({
  isOpen,
  stateLabel,
  currentMonthYear,
  removalPreference = 'always_ask',
  onClose,
  onAddSighting,
  onRemoveSighting,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const monthReadable = currentMonthYear ? currentMonthYear.replace('-', ' ') : currentMonthYear;
  const removePastDisabled = removalPreference === 'current_month_only';

  return (
    <div className="orange-choice-overlay" role="dialog" aria-modal="true" aria-labelledby="orange-choice-title" onClick={onClose}>
      <div className="orange-choice-modal" onClick={(e) => e.stopPropagation()}>
        <div className="orange-choice-modal__accent" aria-hidden="true" />
        <div className="orange-choice-modal__inner">
          <h2 id="orange-choice-title" className="orange-choice-modal__title">
            {stateLabel || 'Spotted in an earlier month'}
          </h2>
          <p className="orange-choice-modal__subtitle">
            {stateLabel ? (
              <>
                You haven’t logged it for <strong>{monthReadable || 'this month'}</strong> yet, but you have for an
                earlier month.{' '}
                {removePastDisabled ? (
                  <>Add it for this month, or change Account settings if you need to remove older months.</>
                ) : (
                  <>Add it now, or remove a past month’s entry.</>
                )}
              </>
            ) : (
              <>
                {removePastDisabled
                  ? 'Add this plate for the current month. (Removing past months is off in your Account settings.)'
                  : 'Add this plate for the current month, or remove it from a past month.'}
              </>
            )}
          </p>
          <div className="orange-choice-modal__actions">
            <button type="button" className="orange-choice-modal__btn orange-choice-modal__btn--add" onClick={onAddSighting}>
              Add for current month
              {monthReadable ? (
                <span className="orange-choice-modal__btn-hint">{monthReadable}</span>
              ) : null}
            </button>
            <button
              type="button"
              className={`orange-choice-modal__btn orange-choice-modal__btn--remove${removePastDisabled ? ' orange-choice-modal__btn--disabled' : ''}`}
              disabled={removePastDisabled}
              onClick={onRemoveSighting}
            >
              Remove from a past month
              <span className="orange-choice-modal__btn-hint">
                {removePastDisabled
                  ? 'Not available with your current setting'
                  : 'You’ll pick which month next'}
              </span>
            </button>
            {removePastDisabled ? (
              <p className="orange-choice-modal__remove-note">
                Under <strong>Account</strong> → <strong>Removing plates</strong>, you chose to only remove sightings
                from the current month. Turn off that option to remove plates from earlier months.
              </p>
            ) : null}
          </div>
          <button type="button" className="orange-choice-modal__cancel" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrangeStateChoiceModal;
